<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div style="padding: 20px 5px 20px 5px;">
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Как сгенерировать
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Загрузите изображение из вашей медиатеки ниже - это может быть как фотография, так и
                                любой набросок или рисунок. Вы можете изменить размер или переместить зону выбранного
                                изображения.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                            <button @click="counter += 1" class="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Какое изображение подойдет
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Выбирайте контрастные фотографии и изображения с крупными деталями - например лица. Цвет
                                фона должен быть конрастным не однотонным.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Как создать картину
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Чтобы получить схему с инструкцией, перейдите по QR-коду, который находится на
                                внутренней стороне холста или уже имеющийся код укажите в разделе <router-link to="/qr_code">Ввести код</router-link>.
                                Нарисовать картину по схеме обычно занимает 10-12 часов -
                                поэтому не старайтесь все сделать за один день.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <cropper id="cropper" style="width: 100%; aspect-ratio: 1 / 1; padding-top: 20px;"
                     ref="cropper"
                     :src="crop_img"
                     :auto-zoom="true"
                     :stencil-props="{
                                handlers: {},
                                movable: false,
                                scalable: false,
                                aspectRatio: aspectRatio,
                            }"
                     :resize-image="{adjustStencil: false}"
                     image-restriction="stencil"

            />
            <div class="row justify-content-between align-items-end" style="padding: 10px 0 30px 0;">
                <div class="col-lg-6 col-sm-12" style="margin-top: 10px;">
                    <div class="selected_color">
                        <label for="formFile" class="form-label">Загрузите вашу картинку (макс 15Мб)</label>
                        <input class="form-control" type="file" id="formFile" accept="image/jpeg"
                               @change="changeImgCrop">
                    </div>
                </div>
                <div class="col-lg-6 col-sm-12 text-center" style="margin-top: 10px;">
                    <button @click="crop" type="button" class="btn btn-outline-secondary selected_color">
                        Посмотреть результат
                    </button>
                </div>
            </div>
            <div style="padding-bottom: 20px; aspect-ratio: 100/35;">
                <transition name="slide-fade">
                    <div v-if="show_result">
                        <div class="row justify-content-evenly">
                            <div class="col-lg-4 col-md-5 col-6">
                                <img :src="a1_src" style="width: 100%; border: solid 4px lightgray">
                                <p class="text-center" style="padding: 20px 0 0 20px"><b>Палитра - Глянец</b>
                                    <br> Можно купить на сайте <a href="https://ozon.ru/t/DK24PB4"
                                                                  target="_blank">OZON</a></p>

                            </div>
                            <div class="col-lg-4 col-md-5 col-6">
                                <img :src="m1_src" style="width: 100%; border: solid 4px lightgray">
                                <p class="text-center" style="padding: 20px 0 0 20px"><b>Палитра - Металлик</b>
                                    <br> Можно купить на сайте <a href="https://ozon.ru/t/d5RNBp8"
                                                                  target="_blank">OZON</a></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="card mb-3">
                                    <div class="card-body">
                                        <h5 class="card-title">Уже есть наш набор ?</h5>
                                        <p class="card-text">Переходите
                                            <router-link to="/qr_code">к подбору фотографии</router-link>
                                            с цветовой палитрой для
                                            вашего набора и возможностью выбирать контраст готовой картины.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </transition>
            </div>
            <div id="pl" v-if="show_spinner">
                <grid-loader class="sp" :loading="true" color="blue"></grid-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import {Cropper} from "vue-advanced-cropper";
    import "vue-advanced-cropper/dist/style.css";
    import img_preview from "@/img/preview.jpg";

    import GridLoader from 'vue-spinner/src/GridLoader.vue'

    export default {
        name: "DemoN",
        components: {
            Cropper,
            GridLoader
        },
        data() {
            return {
                crop_img: img_preview,
                aspectRatio: 1,
                show_spinner: false,
                show_result: false,
                a1_src: null,
                m1_src: null,
            }
        },
        methods: {
            async crop() {
                const {canvas} = this.$refs.cropper.getResult();
                const imgURL = canvas.toDataURL();

                try {
                    this.show_result = false;
                    this.show_spinner = true;
                    const response = await
                        this.$axios.post('/demo',
                            {
                                imgURL: imgURL,
                            });

                    this.a1_src = `data:image/jpeg;base64,${response.data.imgs[0]}`;
                    this.m1_src = `data:image/jpeg;base64,${response.data.imgs[1]}`;

                    this.show_spinner = false;
                    this.show_result = true;
                } catch (e) {
                    console.log(e);
                    console.log('Ошибка передачи файла');
                    this.show_spinner = false;
                    this.show_result = true;
                }
            },
            changeImgCrop(e) {
                const image = e.target.files[0];
                // Проверка на размер
                if (image.size > 15 * 1024 * 1024) {
                    alert('Слишком большой файл');
                    return
                }
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.crop_img = e.target.result;
                };
            },
        },
    }
</script>

<style scoped>

</style>